import * as Core from '@skylab-shared/core';
import { Weaver } from '@skylab-shared/core';
import { InventoryModel } from '@skylab-shared/dataModel';

@Core.BO({ modelType: InventoryModel })
export class InventoryBO extends Core.BusinessObjectBase<InventoryModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }
}
